// TCKN (11 hane) ve VKN (10 hane) format + algoritma (checksum) doğrulaması.
export const onlyDigits = (s) => String(s || "").replace(/\D/g, "");

export function isValidTckn(v) {
  const d = onlyDigits(v);
  if (d.length !== 11 || d[0] === "0") return false;
  const n = d.split("").map(Number);
  const odd = n[0] + n[2] + n[4] + n[6] + n[8];
  const even = n[1] + n[3] + n[5] + n[7];
  const d10 = (((odd * 7 - even) % 10) + 10) % 10;
  if (d10 !== n[9]) return false;
  const sum10 = n.slice(0, 10).reduce((a, b) => a + b, 0);
  return sum10 % 10 === n[10];
}

export function isValidVkn(v) {
  const d = onlyDigits(v);
  if (d.length !== 10) return false;
  const n = d.split("").map(Number);
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    const tmp = (n[i] + (9 - i)) % 10;
    if (tmp === 0) { sum += 0; continue; }
    const p = (tmp * Math.pow(2, 9 - i)) % 9;
    sum += p === 0 ? 9 : p;
  }
  const last = (10 - (sum % 10)) % 10;
  return last === n[9];
}

// Ham girdiye göre {valid, type, message} döndürür. valid: true/false/null (null = henüz değerlendirilmedi).
export function taxIdInfo(raw) {
  const d = onlyDigits(raw);
  if (!d) return { valid: null, type: null, message: "" };
  if (d.length === 11) {
    const ok = isValidTckn(d);
    return { valid: ok, type: "TCKN", message: ok ? "Geçerli TCKN" : "TCKN algoritması geçersiz — rakamları kontrol edin" };
  }
  if (d.length === 10) {
    const ok = isValidVkn(d);
    return { valid: ok, type: "VKN", message: ok ? "Geçerli VKN" : "VKN algoritması geçersiz — rakamları kontrol edin" };
  }
  return { valid: false, type: null, message: `VKN 10, TCKN 11 haneli olmalı (şu an ${d.length} hane)` };
}
